<template>
  <div class="basic">
    <div class="basic-header">
      <p>- 企业基本信息 -</p>
    </div>
    <van-form label-width="" @submit="handleSubmit" ref="basicForm" validate-first @failed="onFailed">
      <!-- 企业基本信息   -->
      <p class="label_p"> <span class="label_spanR">*</span>企业名称/ Company Name</p>
      <van-field v-model="formInline.companyName" name="companyName"  placeholder="请输入企业名称/Please enter Company Name" :rules="ruleInline.companyName" />
      <p class="label_p"> <span class="label_span"></span>简称 / Abbreviation</p>
      <van-field v-model="formInline.companyNameShort" name="companyNameShort" label="" placeholder="请输入简称/Please enter Abbreviation" :rules="ruleInline.companyNameShort" />
      <p class="label_p"> <span class="label_span"></span>英文名称 / English Name</p>
      <van-field v-model="formInline.companyNameEn" name="companyNameEn" label="" placeholder="请输入英文名称/Please enter English Name" :rules="ruleInline.companyNameEn" />
      <p class="label_p"> <span class="label_spanR">*</span>社会信用代码 / Social credit code</p>
      <van-field  v-model="formInline.creditCode" name="creditCode" label="" placeholder=" 请输入信用代码/Please enter Social credit code" :rules="ruleInline.creditCode" />
      <div>
        <van-field required readonly clickable name="addresss" :value="selectAddresTxt" right-icon="arrow" label="城市" placeholder="请选择" :rules="ruleInline.addresss" @click="showPicker = true" />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker show-toolbar :columns="areaList" @confirm="onConfirm" />
        </van-popup>
      </div>
      <p class="label_p"> <span class="label_spanR">*</span>详细地址 / Detailed address</p>
      <van-field v-model="formInline.address" name="address" label="" placeholder="请输入详细地址/Please enter Detail address" :rules="ruleInline.address" />
      <p class="label_p"> <span class="label_span"></span>邮编/ Postcode</p>
      <van-field v-model="formInline.postcode" name="postcode" label="" placeholder="请输入邮编/Please enter Postcode" :rules="ruleInline.postcode" />
      <p class="label_p"> <span class="label_span"></span>网址 / Website</p>
      <van-field v-model="formInline.website" name="website" label="" placeholder=" 请输入网址/Please enter Website" :rules="ruleInline.website" />
      <van-field name="isBelongChild" label="属于子集团公司 / Belong Subsidiaries"  label-width="18em">
        <template #input>
          <van-switch v-model="formInline.isBelongChild" size="20" />
        </template>
      </van-field>
      <van-field v-model="formInline.parentCompanyName" placeholder="请注明母公司名称 / Enter parent name" :rules="ruleInline.parentCompanyName" v-show="formInline.isBelongChild" />
      <div>
        <div class="tip"><span class="red">*</span><span class="txt1" style="font-weight:normal;">企业营业执照 / Company registration certificate</span>
          <p class="txt2">（仅支持jpg，png，不超过2M）</p>
        </div>
        <div style="display:flex">
          <Upload v-show="!uploadList.length" ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg', 'png']" :max-size="2048"
            :headers="formHeaders" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :action="uploadUrl" style="margin-right: 10px">
            <div class="upload-btn">
              <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202206/48845b1fb57c4e3cadb728a83c364788.png">
              <div>上传营业执照</div>
            </div>
          </Upload>
          <div class="upload-btn2" v-if="uploadList && uploadList[0]">
            <img :src="uploadList[0].url">
            <div class="cover">
              <Icon type="ios-trash-outline" @click="handleRemoveByArr(uploadList[0])" style="color:#fff;font-size: 30px;margin-top: 37px;"></Icon>
            </div>
          </div>
        </div>
      </div>
      <!-- 企业基本信息 end  -->

      <div class="gap"></div>

      <!-- 展会联系人信息   -->
      <div class="top-title">
        <div class="line"></div>
        展会联系人 / Contact Person<span>*</span>
      </div>
      <p class="label_p"> <span class="label_spanR">*</span>姓名 / Name</p>
      <van-field  v-model="formInline.linkMan" name="linkMan" label="" placeholder="请输入姓名/Please enter Name" :rules="ruleInline.linkMan" />
      <p class="label_p"> <span class="label_spanR">*</span>职务 / Position</p>
      <van-field  v-model="formInline.linkTitle" name="linkTitle" label="" placeholder="请输入职务/Please enter Position" :rules="ruleInline.linkTitle" />
      <p class="label_p"> <span class="label_spanR">*</span>手机 / Tel</p>
      <van-field type="number"  v-model="formInline.linkMob" name="linkMob" label="" placeholder="请输入手机/Please enter Tel " :rules="ruleInline.linkMob" />
      <p class="label_p"> <span class="label_spanR">*</span>邮箱 / Email</p>
      <van-field  v-model="formInline.linkEmail" name="linkEmail" label="" placeholder="请输入邮箱/Please enter Email" :rules="ruleInline.linkEmail" />
      <p class="label_p"> <span class="label_span"></span>座机电话 / Landline</p>
      <van-field type="number" v-model="formInline.linkTelephone" name="linkTelephone" label="" placeholder="座机电话号码（示例：051-85055112）" :rules="ruleInline.linkTelephone" />
      <p class="label_p"> <span class="label_span"></span>QQ</p>
      <van-field type="number" v-model="formInline.linkQQ" name="linkQQ" label="" placeholder="请输入QQ/Please enter QQ" />
      <p class="label_p"> <span class="label_span"></span>微信 / WeChat</p>
      <van-field v-model="formInline.linkWeChat" name="linkWeChat" label="" placeholder="请输入微信/Please enter WeChat" />
      <!-- 展会联系人信息 end -->

      <div class="gap"></div>

      <!-- 市场部负责人信息   -->
      <div class="top-title">
        <div class="line"></div>
        市场部负责人<span>*</span>
        <div class="top-title-left">
          <span @click="copyLinkInfo" style="color: #00a0e9;">复制展会联系人信息</span>
        </div>
      </div>
      <p class="label_p"> <span class="label_spanR">*</span>姓名 / Name</p>
      <van-field  v-model="formInline.leader" name="leader" label="" placeholder="请输入姓名/Please enter Name" :rules="ruleInline.leader" />
      <p class="label_p"> <span class="label_spanR">*</span>职务 / Position</p>
      <van-field  v-model="formInline.leaderTitle" name="leaderTitle" label="" placeholder="请输入职务/Please enter Position" :rules="ruleInline.leaderTitle" />
      <p class="label_p"> <span class="label_spanR">*</span>手机 / Tel</p>
      <van-field type="number"  v-model="formInline.leaderMob" name="leaderMob" label="" placeholder="请输入手机/Please enter Tel " :rules="ruleInline.leaderMob" />
      <p class="label_p"> <span class="label_spanR">*</span>邮箱 / Email</p>
      <van-field  v-model="formInline.leaderEmail" name="leaderEmail" label="" placeholder="请输入邮箱/Please enter Email" :rules="ruleInline.leaderEmail" />
      <p class="label_p"> <span class="label_span"></span>座机电话 / Landline</p>
      <van-field type="number" v-model="formInline.leaderTelephone" name="leaderTelephone" label="" placeholder="座机电话号码（示例：051-85055112）" :rules="ruleInline.leaderTelephone" />
      <p class="label_p"> <span class="label_span"></span>QQ</p>
      <van-field type="number" v-model="formInline.leaderQQ" name="leaderQQ" label="" placeholder="请输入QQ/Please enter QQ" />
      <p class="label_p"> <span class="label_span"></span>微信 / WeChat</p>
      <van-field v-model="formInline.leaderWeChat" name="leaderWeChat" label="" placeholder="请输入微信/Please enter WeChat" />
      <!-- 市场部负责人信息 end -->

      <div class="gap"></div>

      <!-- 开票信息   -->
      <div class="top-title">
        <div class="line"></div>
        VAT Invoice(中国增值税发票)<span>*</span>
        <div class="top-title-left">
          <van-checkbox v-model="isInvoice">
          <span>无开票信息<p>No invoice</p></span>
          </van-checkbox>
        </div>
      </div>
      <div v-if="!isInvoice">
        <van-field required v-model="formInline.invoiceTitle" name="invoiceTitle" label="发票抬头" placeholder="发票抬头" :rules="ruleInline.invoiceTitle" />
        <van-field required v-model="formInline.invoiceCode" name="invoiceCode" label="税号" placeholder="税号" :rules="ruleInline.invoiceCode" />
        <van-field required v-model="formInline.invoiceAddress" name="invoiceAddress" label="单位地址" placeholder="单位地址 " :rules="ruleInline.invoiceAddress" />
        <van-field type="number" required v-model="formInline.invoiceTelephone" name="invoiceTelephone" label="电话号码" placeholder="电话号码" :rules="ruleInline.invoiceTelephone" />
        <van-field required v-model="formInline.invoiceBank" name="invoiceBank" label="开户银行" placeholder="开户银行" :rules="ruleInline.invoiceBank" />
        <van-field required v-model="formInline.invoiceBankAccount" name="invoiceBankAccount" label="银行账户" placeholder="银行账户" :rules="ruleInline.invoiceBankAccount" />
        <van-field required name="invoiceType" label="开票类型">
          <template #input>
            <van-radio-group v-model="formInline.invoiceType" direction="horizontal">
              <van-radio name="增值税专票">增值税专票</van-radio>
              <van-radio name="增值税普票">增值税普票</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div>
          <van-field required readonly clickable name="invoiceMalingAdresss" :value="selectAddresTxt2" right-icon="arrow" label="邮寄地址" placeholder="发票邮寄地址" :rules="ruleInline.invoiceMalingAdresss"
            @click="showPicker2 = true" />
          <van-popup v-model="showPicker2" round position="bottom">
            <van-picker show-toolbar :columns="areaList" @confirm="onConfirm2" />
          </van-popup>
        </div>
        <van-field v-model="formInline.invoiceMalingAdress" name="invoiceMalingAdress" label="详细地址" placeholder="详细地址" :rules="ruleInline.invoiceMalingAdress" required />
        <van-field v-model="formInline.invoiceMalingCode" name="invoiceMalingCode" label="邮编" placeholder="邮编" />
        <van-field required v-model="formInline.invoiceRecivePerson" name="invoiceRecivePerson" label="发票收件人" placeholder="发票收件人" :rules="ruleInline.invoiceRecivePerson" />
        <van-field type="number" required v-model="formInline.invoiceReciveTel" name="invoiceReciveTel" label="收件人电话" placeholder="收件人电话" :rules="ruleInline.invoiceReciveTel" />
      </div>

      <!-- 开票信息 end -->

      <div class="gap"></div>

      <!-- <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div> -->
    </van-form>
  </div>
</template>

<script> 
import { Toast } from 'vant';
import mFormAddress from "@components/m-form/m-form-address.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
import country from "@assets/js/country2";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data () {
    const that = this;
    const websiteValid = (value, callback) => {
      if (value) {
        if (/(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    };
    const zhValid = (value, callback) => {
      if (/^[\u4e00-\u9fa5]+$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    // 判断英文
    const enValid = (value, callback) => {
      if (!value) {
        return true;
      } else {
        if (/^(?!\s*$)[A-Za-z0-9._\-\&\(\)\（）\s-]+$/.test(value)) {
          return true;
        } else {
          // callback(new Error('英文名称格式有误'));
          return false;
        }
      }
    };

    const companyAddressValid = (value) => {
      if (that.formInline.addresss.country && that.formInline.addresss.country === '中国') { // 中国 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          return false;
        } else if (!that.formInline.addresss.city) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    };
    const invoiceAddressValid = (value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (that.formInline.invoiceMalingAdresss.country && that.formInline.invoiceMalingAdresss.country === '中国') { // 中国 判断省份和城市是否选择
          if (!that.formInline.invoiceMalingAdresss.province) {
            return false;
          } else if (!that.formInline.invoiceMalingAdresss.city) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    };
    const invoiceTitleValid = (value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const invoiceCodeValid = (value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (value) {
          if (/^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(value)) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    };
    const invoiceAddValid = (value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const invoiceTelephoneValid = (value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const leaderTelephoneValid = (value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const invoiceBankValid = (value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const invoiceBankAccountValid = (value, callback) => {
      console.log('invoiceBankAccountValid', value);
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (that.formInline.invoiceType === '增值税专票') {
          if (!value) {
            return false;
          } else {
            if (/^[0-9]{14,20}$/.test(value)) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          if (!value) {
            return true;
          } else {
            if (/^[0-9]{14,20}$/.test(value)) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    };
    const invoiceTypeValid = (rule, value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const invoiceMalingAdressValid = (rule, value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const invoiceRecivePersonValid = (rule, value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const invoiceReciveTelValid = (rule, value, callback) => {
      if (that.isInvoice) { // 没有发票信息
        return true;
      } else {
        if (!value) {
          return false;
        } else {
          return true;
        }
      }
    };
    const validPhone = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^[1][0-9]{10}$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const validEmail = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const validCreditCode = (value, callback) => {
      if (!value) {
        return true;
      }
      var patrn = /^[0-9A-Z]+$/;
      //var patrn=/[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
      //18位校验及大写校验
      console.log(patrn.test(value), '正则的数据');
      if ((value.length != 18) || (patrn.test(value) == false)) {
        return false;
      }
      else {
        return true;
      }
    };
    return {
      areaList: [],
      showPicker: false,
      showPicker2: false,
      cityCode: '',  //省市区编号，默认
      loading: false,
      isInvoice: false,
      formInline: {
        // 企业基本信息
        companyName: "", // 公司名称
        companyNameShort: "", // 公司简称
        companyNameEn: "",// 公司英文名称
        creditCode: "", // 统一社会信用代码 
        address: "", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县 
        },
        postcode: "",
        isBelongChild: false, // 是否属于集团子公司
        parentCompanyName: '', // 母公司名称

        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码
        linkQQ: "",
        linkWeChat: "",

        // 市场部负责人 
        leader: "",
        leaderTitle: "",
        leaderTelephone: "",
        leaderEmail: "",
        LeaderCode: "",
        leaderMob: "",
        leaderQQ: "",
        leaderWeChat: "",

        // 开票信息 
        invoiceTitle: "",
        invoiceCode: "",
        invoiceAddress: "",
        invoiceTelephone: "",
        invoiceBank: "",
        invoiceBankAccount: "",
        invoiceType: "增值税专票",
        invoiceMalingAdresss: {
          country: "中国", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县 
        },
        invoiceMalingAdress: "",
        invoiceMalingCode: "",
        invoiceRecivePerson: "",
        invoiceReciveTel: "",
        website: "",
      },
      formInline2: {
        // 企业基本信息
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameShort: "连战", // 公司简称
        companyNameEn: "lianzhan",// 公司英文名称
        creditCode: "91310118MA1JM12CX7", // 统一社会信用代码 
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县 
        },
        postcode: "201803",
        isBelongChild: false, // 是否属于集团子公司
        parentCompanyName: null, // 母公司名称

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "13122959676",
        linkEmail: "2624006658@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "05185055112", // 电话号码
        linkQQ: "2624006658",
        linkWeChat: "xiansheng",

        // 市场部负责人 
        leader: "王二",
        leaderTitle: "市场",
        leaderMob: "13122959677",
        leaderEmail: "2624006223@qq.com",
        LeaderCode: "021",
        leaderTelephone: "05185055112",
        leaderQQ: "3524006659",
        leaderWeChat: "wanger",

        // 开票信息 
        invoiceTitle: "慕渊（上海）智能科技有限公司",
        invoiceCode: "91310118MA1JM12CX7",
        invoiceAddress: "上海上海市嘉定区江桥镇金沙江西路1555路慧创国际16号2层",
        invoiceTelephone: "13122959676",
        invoiceBank: "招商银行",
        invoiceBankAccount: "6214837922727635",
        invoiceType: "增值税专票",
        invoiceMalingAdresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县 
        },
        invoiceMalingAdress: "江桥镇金沙江西路1555路慧创国际16号2层",
        invoiceMalingCode: "201803",
        invoiceRecivePerson: "王二",
        invoiceReciveTel: "13122959677",
        website: "",
      },
      ruleInline: {
        // 企业基本信息
        companyName: [
          { required: true, message: "请输入企业名称/Please enter Company Name", trigger: "onBlur" },
          // { validator: zhValid, message: "公司名称格式有误", trigger: "onBlur" },
        ],
        companyNameShort: [
          { required: true, message: "请输入公司简称", trigger: "onBlur" },
          {
            validator: (value) => {
              return /^.{2,4}$/.test(value)
            }, message: '公司简称长度在2到4个字符', trigger: 'onBlur'
          },
        ],
        companyNameEn: [
          { message: "请输入公司英文名称", trigger: "onBlur" },
          { validator: enValid, message: "英文名称格式有误", trigger: "onBlur" },
        ],
        website: [
          { validator: websiteValid, message: "网址格式有误", trigger: "onBlur" }
        ],
        creditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "onBlur",
          },
          {
            message: "请输入正确的统一社会信用代码",
            validator: validCreditCode,
            trigger: "onBlur",
          },
        ],
        addresss: [{
          required: true,
          validator: companyAddressValid, trigger: "onBlur",
          message: '请完善地址'
        }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "onBlur" },
        ],

        // 展会联系人
        linkMan: [{ required: true, message: "请输入姓名", trigger: "onBlur" }],
        linkTitle: [{ required: true, message: "请输入职务", trigger: "onBlur" }],
        linkMob: [
          { required: true, message: '请输入手机号码', trigger: "onBlur" },
          { validator: validPhone, message: "手机号码有误", trigger: "onBlur" }
        ],
        linkEmail: [
          { required: true, message: '请输入邮箱', trigger: "onBlur" },
          {
            validator: validEmail, message: '邮箱地址有误', trigger: "onBlur"
          }
        ],

        // 市场部负责人  
        leader: [{ required: true, message: "请输入负责人姓名", trigger: "onBlur" }],
        leaderTitle: [
          { required: true, message: "请输入负责人职务", trigger: "onBlur" },
        ],
        leaderMob: [
          { required: true, message: '请输入手机号码', trigger: "onBlur" },
          { validator: validPhone, message: "手机号码有误", trigger: "onBlur" },
        ],
        leaderEmail: [
          { required: true, message: '请输入邮箱', trigger: "onBlur" },
          {
            validator: validEmail, message: '邮箱地址有误', trigger: "onBlur"
          }
        ],


        // 开票信息  
        invoiceTitle: [
          { required: true, validator: invoiceTitleValid, message: "请输入发票抬头", trigger: "onBlur" },
        ],
        invoiceCode: [
          { required: true, message: '请输入发票税号', trigger: "onBlur" },
          { validator: invoiceCodeValid, message: "发票税号格式有误", trigger: "onBlur" },
        ],
        invoiceAddress: [
          { required: true, validator: invoiceAddValid, message: "请输入单位地址", trigger: "onBlur" },
        ],
        invoiceTelephone: [
          { required: true, validator: invoiceTelephoneValid, message: "请输入单位电话号码", trigger: "onBlur" },
        ],
        invoiceBank: [
          { required: true, validator: invoiceBankValid, message: "请输入开户银行", trigger: "onBlur" },
        ],
        invoiceBankAccount: [
          { required: true, message: '请输入银行账户', trigger: "onBlur" },
          { validator: invoiceBankAccountValid, message: "银行账号格式有误", trigger: "onBlur" },
        ],
        invoiceType: [
          { required: true, validator: invoiceTypeValid, message: "请输入发票类型", trigger: "onBlur" },
        ],
        invoiceMalingAdresss: [{ required: true, validator: invoiceAddressValid, message: "请完善地址", trigger: "onBlur" }],
        invoiceMalingAdress: [
          { required: true, validator: invoiceMalingAdressValid, message: "请输入详细地址", trigger: "onBlur" },
        ],
        invoiceRecivePerson: [
          { required: true, validator: invoiceRecivePersonValid, message: "请输入发票收件人", trigger: "onBlur" },
        ],
        invoiceReciveTel: [
          { required: true, validator: invoiceReciveTelValid, message: "请输入收件人电话", trigger: "onBlur" },
        ],
      },
      defaultList: [],
      uploadList: [],
    // uploadList: ['https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202304/ec3303b80ba848ecb4a8d8d859bacf11.jpg'],
      uploadName: "",

      isExport: true, // 是否是外销企业
      isListed: true, // 是否是上市公司
      isTop500: true, // 是否是世界五百强
      isMicroEnterprise: true, // 是否为小微企业
      isHighTech: true, // 是否为高新技术企业  

      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框 

      countryList: [],
      provinceArr: [],
      citiesArr: [],


      selectAddresTxt: '',
      selectAddresTxt2: '',


    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
    userId () {
      return this.$route.query.userId;
    },
    applyCompanyId () {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId () {
      return this.$route.query.applyCompanyOrderId;
    },
  },
  created () {
    this.areaList = country;
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
    }),
    getvalidate (prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
        };
        this.validateList.push(opt);
      }
    },
    deteleObject (obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    handleSuccess (res, file) {
      if (res) {
        this.uploadList.push({
          name: this.uploadName,
          url: res.cdnBaseUrl+'/'+res.path,
          status: "finished",
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError (file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize (file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片",

      });
    },
    handleBeforeUpload (e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    handleRemoveByArr (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    addAreaArr () {
      if (this.formInline.exportSalesArea.length > 4) {
        Toast.warning("最多可选五个");
        return;
      }
      this.formInline.exportSalesArea.push([]);
    },
    delAreaArr (i) {
      this.formInline.exportSalesArea.splice(i, 1);
    },
    //资产类型选择框变更
    getselect (value) {
      console.log(value, '类型');
      if (value === "其他") {
        this.isOption = false;
      } else {
        this.isOption = true;
      }
    },
    //同上按钮
    copyLinkInfo () {
      this.formInline.leader = this.formInline.linkMan;
      this.formInline.leaderTitle = this.formInline.linkTitle;
      this.formInline.leaderTelephone = this.formInline.linkTelephone;
      this.formInline.leaderEmail = this.formInline.linkEmail;
      this.formInline.LeaderCode = this.formInline.linkCode;
      this.formInline.leaderMob = this.formInline.linkMob;
      this.formInline.leaderQQ = this.formInline.linkQQ;
      this.formInline.leaderWeChat = this.formInline.linkWeChat;
    },

    async handleSubmit () {
      Toast.loading('loading...');
      setTimeout(() => {
        Toast.clear();
      }, 5000);
      let res = await this.validateHandle();
      console.log('res', res);
      return Promise.resolve(res)
    },
    async validateHandle () {
      return new Promise((resolve, reject) => {
        this.$refs.basicForm.validate().then(() => {
          // 营业执照
          let valid = true;
          let imgBusinessLicense = "";
          if (this.uploadList && this.uploadList.length) {
            imgBusinessLicense = this.uploadList[0];
          } else {
            Toast.fail("请上传营业执照");
            valid = false;
          }
          let codeNum = this.formInline.linkTelephone.split('-');
          if (codeNum.length === 2) {
            this.formInline.linkCode = codeNum[0];
            this.formInline.linkTelephone = codeNum[1];
          }
          let codeNum2 = this.formInline.leaderTelephone.split('-');
          if (codeNum.length === 2) {
            this.formInline.LeaderCode = codeNum2[0];
            this.formInline.leaderTelephone = codeNum2[1];
          }
          let form = this.formInline;
          console.log('form', this.formInline);


          let formValue = {
            website: form.website,
            companyName: form.companyName, // 公司名称
            companyNameShort: form.companyNameShort, // 公司简称
            companyNameEn: form.companyNameEn,// 公司英文名称
            unifiedCode: form.creditCode, // 统一社会信用代码 
            address: form.address, // 详细地址 
            country: form.addresss.country,
            province: form.addresss.province,
            city: form.addresss.city,

            postcode: form.postcode,
            isBelongChild: form.isBelongChild, // 是否属于集团子公司
            parentCompanyName: form.parentCompanyName, // 母公司名称

            // 展会联系人
            linkMan: form.linkMan,
            linkTitle: form.linkTitle,
            linkTelephone: form.linkTelephone,
            linkEmail: form.linkEmail,
            linkCode: form.linkCode, // 区号
            linkMob: form.linkMob, // 电话号码
            linkQQ: form.linkQQ,
            linkWeChat: form.linkWeChat,

            // 市场部负责人 
            leader: form.leader,
            leaderTitle: form.leaderTitle,
            leaderTelephone: form.leaderTelephone,
            leaderEmail: form.leaderEmail,
            LeaderCode: form.LeaderCode,
            leaderMob: form.leaderMob,
            leaderQQ: form.leaderQQ,
            leaderWeChat: form.leaderWeChat,

            // 开票信息 
            invoiceTitle: form.invoiceTitle,
            invoiceCode: form.invoiceCode,
            invoiceAddress: form.invoiceAddress,
            invoiceTelephone: form.invoiceTelephone,
            invoiceBank: form.invoiceBank,
            invoiceBankAccount: form.invoiceBankAccount,
            invoiceType: form.invoiceType,

            invoiceMalingCountry: form.invoiceMalingAdresss.country,
            invoiceMalingProvince: form.invoiceMalingAdresss.province,
            invoiceMalingCity: form.invoiceMalingAdresss.city,

            invoiceMalingAdress: form.invoiceMalingAdress,
            invoiceMalingCode: form.invoiceMalingCode,
            invoiceRecivePerson: form.invoiceRecivePerson,
            invoiceReciveTel: form.invoiceReciveTel,
            imgBusinessLicense: JSON.stringify({ name: "", url: imgBusinessLicense }),
          }
          Toast.clear();
          resolve({ valid: valid, form: formValue });
        }).catch((res) => {
          //验证失败
          console.log(res) 
          this.$refs.basicForm.scrollToField(res[0].name, true)
          Toast.fail(res[0].message);
          resolve({ valid: false, form: null });
        })
      });
    },
    onConfirm (value) {
      this.formInline.addresss.country = value[0] || '';
      this.formInline.addresss.province = value[1] || '';
      this.formInline.addresss.city = value[2] || '';
      this.selectAddresTxt = `${this.formInline.addresss.country ? this.formInline.addresss.country : ''}${this.formInline.addresss.province ? '/' + this.formInline.addresss.province : ''}${this.formInline.addresss.city ? '/' + this.formInline.addresss.city : ''}`;
      this.showPicker = false;
    },
    onConfirm2 (value) {
      this.formInline.invoiceMalingAdresss.country = value[0] || '';
      this.formInline.invoiceMalingAdresss.province = value[1] || '';
      this.formInline.invoiceMalingAdresss.city = value[2] || '';
      this.selectAddresTxt2 = `${this.formInline.invoiceMalingAdresss.country ? this.formInline.invoiceMalingAdresss.country : ''}${this.formInline.invoiceMalingAdresss.province ? '/' + this.formInline.invoiceMalingAdresss.province : ''}${this.formInline.invoiceMalingAdresss.city ? '/' + this.formInline.invoiceMalingAdresss.city : ''}`;
      this.showPicker2 = false;
    },
    onFailed (failed) {
      const errors = failed.errors;
      console.log(errors);
      this.$refs.basicForm.scrollToField(errors[0].name, true)
    }
  },
};
</script>

<style scoped lang='scss'>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #00a0e9 !important;
    }
    .van-switch--on,
    .ivu-radio-inner:after {
      background-color: #00a0e9;
    }
    .van-button--info,
    .van-radio__icon--checked .van-icon,
    .ivu-switch-checked {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }
  }
  &-header {
    width: 100%;
    height: 48px;
    background-color: #00a0e9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 48px;
      font-size: 15px;
    }
    span {
      width: 30px;
      height: 15px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 105px;
    height: 105px;
    border: dotted 1px #bfbfbf;
    text-align: center;
    margin: 10px 16px;
    border-radius: 4px;
    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-top: 33px;
      margin-bottom: 10px;
    }
    div {
      font-size: 12px;
      color: #999;
    }
  }
  .license-img {
    display: flex;
    flex-wrap: wrap;
    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;
      span {
        color: #00a0e9;
        cursor: pointer;
      }
      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;
    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;
      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    .ivu-checkbox-wrapper {
      margin: 0;
    }
    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}
.tip {
  padding: 10px 16px 0;
  .red {
    font-size: 12px;
    color: #f00;
  }
  .txt1 {
    font-size: 13px;
    color: #000;
    font-weight: bold;
  }
  .txt2 {
    font-size: 12px;
    color: #999;
  }
}
.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}
.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #00a0e9;
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    color: #f00;
  }
  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
.upload-btn2 {
  width: 105px;
  height: 105px;
  border: dotted 1px #bfbfbf;
  text-align: center;
  margin: 10px 16px;
  border-radius: 4px;
  position: relative;
  margin-left: 10px;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .cover {
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 3;
    .icon {
    }
  }
}
.label_p{
    margin: 0.5em 0 0em 0;
}
.label_spanR{
    color:red;margin-left:0.5em
}
.label_span{
    color:red;margin-left:1em
}

</style>
